module.exports = __webpack_public_path__ + "static/media/VoiceNews.8b7acb9a.png";